export const REGEX = {
  allNumbers: /^\d+$/,
  excludeNumbersAndDot: /[^\d.]/,
  firstAndLastDots: /(\..*)\./g,
  numbersWithEndingDot: /^\d+\.$/,
};
